import { Component } from 'react';
import Modal from '../layout/Modal'

const placement = [
    "place-self-start", "place-self-end", "place-self-center"
];

const jsonFile = process.env.PUBLIC_URL + '/util.json';


class Calendar extends Component {
    constructor() {
        super();
        
        this.state = {
            show: false,
            numArr: [],
            orderArr: [],
            placementNumber: [],
            actualDate: new Date(),
            opendNum: 0,
            settings: false,
            doors: false
        }
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    showModal = (num) => {
        this.setState({show: true, opendNum: num})
    }

    hideModal = () => {
        this.setState({show: false, opendNum: 0})
    }

    


    componentDidMount() {
        const arr = [...Array(25).keys()].splice(1);
        let order = [...Array(25).keys()].splice(1).sort(() => Math.random() - 0.5)
        let placementArr = []

        for (let i = 0; i < arr.length; i++) {
            placementArr.push(Math.floor(Math.random() * placement.length))
        }

        this.setState({
            numArr: arr,
            orderArr: order,
            placementNumber: placementArr,
        })

        fetch(jsonFile)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            settings: result.settings,
            doors: result.doors
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
        
    }
    render() {
        return (
            <div className="w-full max-w-mb h-screen z-0" >
                
                <div className="flex justify-between my-0 mx-auto w-full max-h-48 p-4 bg-white">
                {
                    this.state.settings["logo_header"] === "" ? "" : <img className=" w-20 left-0 max-w-xs" src={this.state.settings["logo_header"]} alt="logo"/> 
                }
                </div>
                <div className="flex justify-between min-h-90 p-4 pb-10 flex-wrap bottom-10 bg-no-repeat bg-center bg-cover" style={{backgroundImage:'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('+ this.state.settings['background-image'] +')'}}>

                <Modal show={this.state.show} handleClose={this.hideModal}>
                    {this.state.opendNum <= this.state.actualDate.getDate() && this.state.actualDate.getMonth() === 11 && this.state.opendNum !== 0 ? 
                    <Door doornumber={this.state.opendNum} data={this.state.doors} /> : this.state.settings["wrong_day_message"]}
                </Modal>
                

                {this.state.orderArr.map((order) => {
                return (
                    <div key={order.toString()} className={"flex m-2 flex-shrink-0 order-" + order + " place-self-center  justify-center items-center h-20 w-20 hoverbg lg:h-24 lg:w-24"}>
                        <button onClick={() => this.showModal(this.state.orderArr[order - 1])} id={"window-"+this.state.orderArr[order - 1]+""} className="h-full w-full font-playfair text-white text-6xl lg:text-7xl"> {this.state.orderArr[order - 1]} </button>
                    </div>
                    )
                })}                    
                </div>
                <div className="relative bottom-0 flex justify-between my-0 mx-auto w-full max-h-48 p-4 bg-white z-0" dangerouslySetInnerHTML={{__html: this.state.settings["footer"]}}>
                    
                </div>
            </div>
        )
    }
}

function Door(props){
    const doorData = props.data[props.doornumber];
    return(
        <div className="overflow-auto p-4">
            {
                doorData["headline"] === "" ? "" : <h1 className="text-2xl pb-4" dangerouslySetInnerHTML={{__html: doorData["headline"]}}></h1>
            }
            
            <div className="flex justify-center">
                {
                    doorData["videolink"] === "" ? "" 
                    : <iframe title={doorData["headline"]} className=" justify-center w-full h-44 md:w-3/4 md:h-60" src={doorData["videolink"]} allowFullScreen></iframe>

                }
            </div>
                {
                    doorData["image"] === "" ? "" : <a className="flex justify-center p-4" target="_blank" rel="noreferrer" href={doorData["image_url"]}><img src={doorData["image"]} alt={doorData["headline"]}/></a>
                }
            
            {
                doorData["content"] === "" ? "" :  <div className="text-center" dangerouslySetInnerHTML={{__html: doorData["content"]}}></div> 
            }
            
            {/* <div className="releative md:absolute bottom-0 mt-4 pb-1 md:pb-8">{doorData["footer"]}</div> */}
        </div>
    )
}

export default Calendar;

